import axios from 'axios';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/usuario/gov';

class GovService {
    /**
     * Inicia o fluxo de autenticação com o GOV.BR no backend.
     * Chama via POST o endpoint /api/usuario/gov/iniciar
     *
     * @param {string} idCliente Identificador do cliente (tenant)
     * @param {boolean} redirect Se true, o próprio backend efetua o HTTP 302 redirect
     * @returns {Promise} Retorna Promise com a resposta ({ idRequisicao, urlChamadaGovbr })
     */
    iniciarLoginGov(idCliente, redirect = false) {
        return axios.post(`${API_URL}/iniciar`, null, {
            params: {
                idCliente: idCliente || undefined,
                redirect: redirect
            }
        });
    }

}

export default new GovService();
